interface GMBErrorStateProps {
  title?: string;
  message?: string;
  onRetry?: () => void;
}

export default function GMBErrorState({
  title = 'Failed to load governance data',
  message,
  onRetry,
}: GMBErrorStateProps) {
  return (
    <div className="bg-red-50 dark:bg-red-900/20 border border-red-200 dark:border-red-800 rounded-xl p-6 text-center">
      <i className="ri-error-warning-line text-red-500 text-3xl mb-3 block"></i>
      <h3 className="text-sm font-semibold text-red-800 dark:text-red-200">{title}</h3>
      {message && <p className="text-xs text-red-600 dark:text-red-400 mt-1">{message}</p>}
      {onRetry && (
        <button
          onClick={onRetry}
          className="mt-3 px-4 py-2 bg-red-600 text-white rounded-lg text-sm font-medium hover:bg-red-700"
        >
          Retry
        </button>
      )}
    </div>
  );
}